import { createReducer } from "@reduxjs/toolkit";
import type { CreationState } from "@redux/state/shared-types";
import { documentaryResourceCreate, documentaryResourceCreateReset } from "./documentary-resource-create";

const initialState: CreationState = { justCreatedId: null, processing: "idle" };

export const documentaryResourceCreateReducer = createReducer<CreationState>(initialState, builder => {
  builder.addCase(documentaryResourceCreate.fulfilled, (state, { payload }) => {
    return {
      ...state,
      justCreatedId: payload,
      processing: "success",
    };
  });
  builder.addCase(documentaryResourceCreate.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(documentaryResourceCreate.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(documentaryResourceCreateReset, () => {
    return initialState;
  });
});
